import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { withNamespaces, Trans } from 'react-i18next';

import Button from 'components/Button';

const FOLLOW_SIZE = {
  xsmall: 'xsmall',
  small: 'small',
  default: 'default',
};

class HoverState {
  @observable justFollowed = false;
  @observable hovered = false;
  @action Reset() {
    this.justFollowed = false;
    this.hovered = false;
  }
}

@withNamespaces()
@observer
export class Follow extends React.Component {
  constructor(props) {
    super(props);
    this.hoverState = new HoverState();
  }

  render() {
    const { content, show = true } = this.props;
    if (!show) return null;

    const { isFollowed, UnFollow, FollowUser } = content;
    if (isFollowed) {
      if (this.hoverState.hovered && !this.hoverState.justFollowed) {
        return (
          <Button
            text={<Trans>Unfollow</Trans>}
            size={this.props.size || 'xsmall'}
            variant='destructive'
            onMouseLeave={() => this.hoverState.Reset()}
            onClick={() => UnFollow()}
            icon='close'
            outline
          />
        );
      }
      return (
        <Button
          text={<Trans>Following</Trans>}
          size={this.props.size || 'xsmall'}
          onMouseEnter={() => {
            this.hoverState.hovered = true;
          }}
          onMouseLeave={() => this.hoverState.Reset()}
          icon='check'
          outline
        />
      );
    }
    return (
      <Button
        text={<Trans>Follow</Trans>}
        size={this.props.size || 'xsmall'}
        onClick={() => {
          FollowUser();
          this.hoverState.justFollowed = true;
        }}
        icon='add'
        outline
      />
    );
  }
}

Follow.propTypes = {
  content: PropTypes.object,
  size: PropTypes.oneOf(Object.values(FOLLOW_SIZE)),
  show: PropTypes.bool,
};
